import Vue, { CreateElement } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { VIcon } from 'vuetify/lib';
@Component({
  name: 'AboutApartmentRuleItem',
})
export default class AboutApartmentRuleItem extends Vue {
  @Prop({ type: String, default: null}) public readonly name!: string;
  @Prop({ type: Boolean, default: null}) public readonly value!: boolean;

  private render(createElement: CreateElement) {
    return createElement('div', {
      class: ['rule-item', 'display-f'],
    }, [
      this.value !== null && this.value
        ? createElement(VIcon, '$vuetify.icons.rule_checked')
        : createElement(VIcon, '$vuetify.icons.rule_unchecked'),
      createElement('p', this.name),
    ]);
  }
}
